module.exports = __webpack_public_path__ + "img/VE.40fc3c9b.png";